export const checkDeployEnv = (env) => {
  return process.env.REACT_APP_ENV === env || process.env.REACT_APP_ENV === env;
};

export const isProdEnv = () => {
  return checkDeployEnv('production') || checkDeployEnv('demo');
};

export const isProdEnvOnly = () => {
  return checkDeployEnv('production');
};

export const isDemoEnvOnly = () => {
  return checkDeployEnv('demo');
};
